module.exports = __webpack_public_path__ + "img/pic1.8d840279.png";